import React, { useState, ChangeEvent } from "react";
import * as palette from "@govlaunch/palette";
import mediaQueries from "~/lib/utils/mediaQueries";
import { Padding, Margin } from "~/components/spacings";
import { Grid, Row, Col, Input } from "@govlaunch/core";
import { IFlatResource } from "~/types/types";
import FullLogo from "~/components/group/FullLogo";
import InlineResource from "~/components/resource/InlineResource";
import NoResultsFound from "~/components/group/NoResultsFound";
import { useIntl, FormattedMessage } from "react-intl";

export default function Resources({ resources }: { resources: IFlatResource[] }) {
  const intl = useIntl();
  const [filter, setFilter] = useState("");
  const filtered = resources.filter((resource) => {
    if (!filter || !resource.title) {
      return true;
    }

    return resource.title.toLowerCase().includes(filter.toLowerCase());
  });

  return (
    <Padding py={48}>
      <Grid>
        <Row>
          <Col width={[1, 8 / 12]} mx="auto">
            <div
              data-intercom-target="Group Resources"
              css={{
                borderRadius: 5,
                border: `1px solid ${palette.lightestGray}`,
                background: "#fff",
              }}
            >
              <div
                css={{
                  padding: 16,
                  display: "flex",
                  borderBottom: `1px solid ${palette.lightestGray}`,
                }}
              >
                <span
                  css={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: palette.sealBlue,
                    textTransform: "uppercase",
                  }}
                >
                  <FormattedMessage
                    defaultMessage="Resources {count}"
                    id="8RZ7S6"
                    values={{ count: resources.length }}
                  />
                </span>
              </div>

              <div
                css={{
                  padding: 16,
                }}
              >
                <Margin mb={16}>
                  <Input
                    placeholder={intl.formatMessage({
                      defaultMessage: "Search for resources",
                      id: "LMtgBp",
                    })}
                    value={filter}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setFilter(e.target.value)}
                  />
                </Margin>

                <div
                  css={mediaQueries({
                    display: "grid",
                    gridTemplateColumns: ["1fr", "1fr", "1fr 1fr 1fr"],
                    gridColumnGap: 16,
                    gridRowGap: 16,
                  })}
                >
                  {filtered.length === 0 && filter.length > 0 && <NoResultsFound />}
                  {filtered.map((resource, index) => (
                    <InlineResource resource={resource} color={palette.primary} key={index} />
                  ))}
                </div>
              </div>
            </div>

            <Margin mt={48}>
              <div
                css={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <FullLogo color={palette.mediumGray} width={218} height={48} />
              </div>
            </Margin>
          </Col>
        </Row>
      </Grid>
    </Padding>
  );
}
